import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';

const BioSection = ({ formData, errors, onChange }) => {
  const [charCount, setCharCount] = useState(formData?.bio?.length || 0);
  const maxChars = 500;

  const handleBioChange = (e) => {
    const value = e?.target?.value;
    if (value?.length <= maxChars) {
      setCharCount(value?.length);
      onChange(e);
    }
  };

  const bioSuggestions = [
    "Looking for meaningful connections without judgment",
    "Seeking discreet companionship and genuine conversations",
    "Open to exploring new connections in a safe space",
    "Here for authentic interactions and mutual respect",
    "Interested in building connections based on understanding"
  ];

  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleSuggestionClick = (suggestion) => {
    onChange({ target: { name: 'bio', value: suggestion } });
    setCharCount(suggestion?.length);
    setShowSuggestions(false);
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold">About You</h3>
        <button
          type="button"
          onClick={() => setShowSuggestions(!showSuggestions)}
          className="flex items-center gap-2 px-3 py-1.5 bg-muted text-foreground rounded-lg text-sm font-caption font-medium transition-smooth hover:bg-muted/80"
        >
          <Icon name="Lightbulb" size={16} />
          Suggestions
        </button>
      </div>
      <div className="space-y-4">
        <div className="relative">
          <label className="block text-sm font-caption font-medium mb-2">
            Bio <span className="text-error">*</span>
          </label>
          <textarea
            name="bio"
            value={formData?.bio}
            onChange={handleBioChange}
            placeholder="Tell others about yourself, your interests, and what you're looking for..."
            className={`w-full min-h-[120px] md:min-h-[150px] px-4 py-3 bg-input border rounded-lg text-sm resize-none transition-smooth focus:outline-none focus:ring-2 focus:ring-ring ${
              errors?.bio ? 'border-error' : 'border-border'
            }`}
            maxLength={maxChars}
          />
          <div className="flex items-center justify-between mt-2">
            <span className={`text-xs font-caption ${charCount > maxChars * 0.9 ? 'text-warning' : 'text-muted-foreground'}`}>
              {charCount}/{maxChars} characters
            </span>
            {errors?.bio && (
              <span className="text-xs text-error">{errors?.bio}</span>
            )}
          </div>
        </div>

        {showSuggestions && (
          <div className="p-4 bg-muted rounded-lg space-y-2 animate-slide-down">
            <h4 className="text-sm font-caption font-semibold mb-3 flex items-center gap-2">
              <Icon name="Sparkles" size={16} color="var(--color-primary)" />
              Bio Suggestions
            </h4>
            {bioSuggestions?.map((suggestion, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleSuggestionClick(suggestion)}
                className="w-full text-left p-3 bg-card rounded-lg text-sm text-foreground transition-smooth hover:bg-primary/10 hover:text-primary"
              >
                {suggestion}
              </button>
            ))}
          </div>
        )}

        <div className="p-4 bg-success/10 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-caption font-semibold mb-1 text-success">Writing Tips</h4>
              <ul className="text-xs text-foreground space-y-1">
                <li>• Be genuine and authentic in your description</li>
                <li>• Mention your interests and what makes you unique</li>
                <li>• Keep it positive and respectful</li>
                <li>• Avoid sharing personal contact information</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BioSection;